import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDvxIuXOMMewhFOPjgn8wwpN-IMRPlPjsE",
  authDomain: "donation-mitq.firebaseapp.com",
  projectId: "donation-mitq",
  storageBucket: "donation-mitq.firebasestorage.app",
  messagingSenderId: "1087022928019",
  appId: "1:1087022928019:web:b68deb4f4ee137b7e57d66",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
export const analytics =
  typeof window !== "undefined" ? getAnalytics(app) : null;

export const trackEvent = (eventName, eventParams) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};
